module.exports = __webpack_public_path__ + "static/media/pg.68e1ce33.svg";